<template>
  <div class="container mx-auto">
    <el-dialog
      title="Imprimir Boletas de pago"
      :visible.sync="showPrintPayStub"
      width="30%"
    >
      <el-form
        status-icon
        :model="payStubPrintOptions"
        ref="printPayStub"
        @submit.native.prevent="
          printBoleta(computedEmployees, payStubPrintOptions)
        "
        class="space-y-4"
      >
        <span>Seleccione una opcion para imprimir</span>
        <el-radio-group
          v-model="payStubPrintOptions.type"
          class="w-full"
          @change="payStubPrintOptions.selection = []"
        >
          <el-row :gutter="15">
            <el-col :span="8">
              <el-radio border size="small" :label="1" class="w-full"
                >Todas las boletas</el-radio
              >
            </el-col>
            <el-col :span="8">
              <el-radio border size="small" :label="2" class="w-full"
                >Departamento(s)</el-radio
              >
            </el-col>
            <el-col :span="8">
              <el-radio border size="small" :label="3" class="w-full"
                >Empleados</el-radio
              >
            </el-col>
          </el-row>
        </el-radio-group>
        <el-row :gutter="15">
          <el-col :span="24" v-if="payStubPrintOptions.type == 2">
            <el-form-item label="Seleccionar departamentos">
              <el-select
                remote
                filterable
                multiple
                clearable
                v-model="payStubPrintOptions.selection"
                placeholder="Select"
                class="w-full"
                size="small"
                :remote-method="searchPSOptions"
              >
                <el-option
                  v-for="d in payStubSelectionOptions"
                  :key="d"
                  :label="d"
                  :value="d"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="payStubPrintOptions.type == 3">
            <el-form-item label="Seleccionar empleados">
              <el-select
                remote
                filterable
                multiple
                clearable
                v-model="payStubPrintOptions.selection"
                placeholder="Select"
                class="w-full"
                size="small"
                :remote-method="searchPSOptions"
              >
                <el-option
                  v-for="d in payStubSelectionOptions"
                  :key="d.id"
                  :label="d.name"
                  :value="d.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="showPrintPayStub = false"
              >Cancelar</el-button
            >
            <el-button size="small" type="primary" native-type="submit"
              ><i class="el-icon-printer"></i> Imprimir</el-button
            >
          </el-col></el-row
        >
      </el-form>
    </el-dialog>

    <div class="flex flex-col space-y-4">
      <div class="grid grid-cols-12 gap-4">
        <div class="flex col-span-2">
          <el-select
            v-model="selectedPaysheet"
            placeholder="Nóminas pasadas"
            size="small"
            filterable
            class="w-full"
            @change="getPaysheetData(selectedPaysheet)"
          >
            <el-option
              v-for="o in activePaysheets"
              :key="o.id"
              :label="o.code"
              :value="o.id"
            />
          </el-select>
        </div>
        <div class="flex items-center col-span-6 border rounded px-2">
          <div class="flex space-x-4" v-if="selectedPaysheet != ''">
            <div class="flex space-x-2">
              <h2 class="font-semibold">CÓDIGO:</h2>
              <span>{{
                paysheetDetails != null ? paysheetDetails.code : ""
              }}</span>
            </div>
            <div class="flex space-x-2">
              <h2 class="font-semibold">FECHAS:</h2>
              <span>
                {{ paysheetDetails != null ? paysheetDetails.startDate : "" }} -
                {{ paysheetDetails != null ? paysheetDetails.endDate : "" }}
              </span>
            </div>
            <div class="flex space-x-2">
              <h2 class="font-semibold">TIPO:</h2>
              <span class="uppercase">
                {{
                  paysheetDetails != null
                    ? paysheetDetails.paysheetType.name
                    : ""
                }}
              </span>
            </div>
          </div>
          <div v-else>
            <h2>SELECCIONA O CREA UNA PLANTILLA PARA VER SUS DETALLES</h2>
          </div>
        </div>
        <div class="flex col-span-4 space-x-4">
          <el-input
            v-model="searchValue"
            placeholder="Buscar"
            suffix-icon="el-icon-search"
            size="small"
            clearable
          />
          <el-dropdown trigger="click" v-if="selectedPaysheet.length > 0">
            <el-button icon="el-icon-fa-ellipsis-v" size="small"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="
                  generateGratificationDiscountReport(
                    selectedPaysheet,
                    computedEmployees,
                    'gratificaciones'
                  )
                "
                ><i class="el-icon-download"></i> Descargar
                gratificaciones</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="
                  generateGratificationDiscountReport(
                    selectedPaysheet,
                    computedEmployees,
                    'descuentos'
                  )
                "
              >
                <i class="el-icon-download"></i> Descargar
                descuentos</el-dropdown-item
              >
              <el-dropdown-item
                divided
                @click.native="printSelectedPaysheet(computedEmployees)"
                class="font-semibold"
              >
                <i class="el-icon-printer"></i> Descargar
                planilla</el-dropdown-item
              >
              <el-dropdown-item
                divided
                @click.native="openPrintPayStub()"
                class="font-semibold"
              >
                <i class="el-icon-printer"></i>
                Imprimir boletas
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div
          class="
            flex flex-col
            justify-between
            col-span-2
            bg-gray-100
            h-100
            border
            rounded
            p-3
            sticky
            top-0
            text-xs
          "
          v-loading="loadingPreview"
        >
          <div class="flex flex-col space-y-3">
            <div>
              <span class="font-semibold">Nombre completo</span>
              <template v-if="previewDetail">
                <el-row :gutter="15" style="font-size: 12px">
                  <el-col :span="24">
                    <span style="font-size: 10.5px">{{
                      previewDetail.fullName.split(" - ")[1]
                    }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <el-row :gutter="15">
              <el-col :span="12">
                <span class="font-semibold">D. laborados</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.workedDays}`
                      : ""
                  }}
                </p>
              </el-col>
              <el-col :span="12">
                <span class="font-semibold">D. ausente</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.missedDays}`
                      : ""
                  }}
                </p>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="12">
                <span class="font-semibold">Salario</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.salary}`
                      : ""
                  }}
                </p>
              </el-col>
              <el-col :span="12">
                <span class="font-semibold">Planilla</span>
                <p style="font-size: 10.5px">
                  {{
                    this.previewDetail != null
                      ? `${this.previewDetail.salaryForPayroll}`
                      : ""
                  }}
                </p>
              </el-col>
            </el-row>
            <div>
              <span class="font-semibold">Horas extra</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.horasextra"
                  :key="k"
                  style="font-size: 10.5px"
                >
                  <el-col :span="20">
                    <span class="uppercase"
                      >{{ item.date | formatDate }} /
                      {{ item.overtimeType.name }}</span
                    >
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span>{{ item.hours }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <div class="w-full">
              <span class="font-semibold">Gratificaciones</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.gratificaciones"
                  :key="k"
                  style="font-size: 10.5px"
                >
                  <el-col :span="20">
                    <span class="uppercase">{{
                      item.personalAction.name
                    }}</span>
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span>{{ item.value | formatMoney }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
            <div class="w-full">
              <span class="font-semibold">Descuentos</span>
              <template v-if="previewDetail">
                <el-row
                  :gutter="15"
                  v-for="(item, k) of previewDetail.descuentos"
                  :key="k"
                  style="font-size: 10.5px"
                >
                  <el-col :span="20">
                    <span class="uppercase">{{
                      item.personalAction.name
                    }}</span>
                  </el-col>
                  <el-col :span="4" class="flex justify-end">
                    <span>{{ item.value | formatMoney }}</span>
                  </el-col>
                </el-row>
              </template>
            </div>
          </div>
        </div>
        <div class="col-span-10 flex flex-col space-y-4">
          <div class="flex flex-row justify-end space-x-6 text-sm">
            <div class="flex flex-row items-center space-x-1">
              <span>EMPLEADO SELECCIONADO</span>
              <div class="h-4 w-4 bg-orange-400"></div>
            </div>
          </div>
          <div class="flex flex-col" v-loading="loading">
            <div class="flex flex-col sticky top-0">
              <div class="flex flex-row font-semibold text-xs">
                <span
                  v-for="(h, k) in table.headers"
                  :key="k"
                  class="
                    border-b
                    p-1
                    text-xs
                    font-semibold
                    text-gray-600
                    bg-white
                    borded
                  "
                  :style="{ width: table.width[k] }"
                  :class="[
                    table.classes[k],
                    k == 0 ? 'rounded-tl-lg' : '',
                    k == table.headers.length - 1 ? 'rounded-tr-lg' : '',
                  ]"
                  >{{ h }}</span
                >
              </div>
              <div class="flex flex-row font-semibold text-xs bg-white">
                <span
                  v-for="(h, k) in paysheetTotals"
                  :key="k"
                  class="border-b-2 p-1 text-right border-dashed"
                  :style="{ width: table.width[k] }"
                  >{{ h }}</span
                >
              </div>
            </div>
            <template v-if="filteredEmployees.length > 0">
              <div
                class="flex flex-row text-xs border-b cursor-pointer"
                v-for="(ce, k) of filteredEmployees"
                :class="getRowClasses(k, ce, previewDetail)"
                :key="k"
                @click="showDetails(ce)"
              >
                <div
                  class="p-1"
                  v-for="(h, k) in table.values"
                  :key="k"
                  :style="{ width: table.width[k] }"
                  :class="table.classes[k]"
                >
                  <span v-if="k != table.values.length - 1">{{
                    ce[h] | formatNumber
                  }}</span>
                  <span v-else>{{ ce[h] | formatMoney }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="h-16 flex flex-row justify-center items-center border-b"
              >
                <span class="text-xs text-gray-400">Sin Datos</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { format } from "date-fns";
import * as R from "ramda";
import { formatMoney, formatNumber, printBoleta } from "../../../utils";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "AllPaysheets",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          paysheets { id paysheetType { id name paysheetFrecuency { id days } } month year sequence active code startDate endDate }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              paysheets: data.paysheets,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      loading: false,
      searchValue: "",
      previewDetail: null,
      loadingPreview: false,
      paysheets: [],
      selectedPaysheet: "",
      table: {
        headers: [
          "",
          "Nombre completo",
          "Días",
          "Salario",
          "Planilla",
          "H. extra",
          "Gratifc.",
          "Subtotal",
          "IGSS",
          "AFP/IPSFA",
          "Renta",
          "Descuen.",
          "Pago",
        ],
        classes: [
          "",
          "",
          "text-center",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right",
          "text-right font-medium",
        ],
        width: [
          "3.5%",
          "26.5%",
          "4%",
          "6%",
          "7%",
          "6.5%",
          "6.5%",
          "7%",
          "6%",
          "6.5%",
          "6.5%",
          "6.5%",
          "7.5%",
        ],
        values: [
          "index",
          "fullName",
          "workedDays",
          "salary",
          "salaryForPayroll",
          "overtime",
          "gratification",
          "subtotalSalary",
          "socialEmployee",
          "afpEmployee",
          "taxes",
          "discounts",
          "total",
        ],
      },
      computedEmployees: [],
      showPrintPayStub: false,
      payStubPrintOptions: {
        type: 1,
        selection: [],
      },
      payStubSelectionOptions: [],
    };
  },
  methods: {
    setData({ paysheets }) {
      this.paysheets = paysheets
        .map((p) => {
          // const [syear, smonth, sday] =
          return {
            ...p,
            startDate: format(p.startDate, "DD/MM/YYYY"),
            endDate: format(p.endDate, "DD/MM/YYYY"),
            startDateRaw: new Date(p.startDate),
            endDateRaw: new Date(p.endDate),
          };
        })
        .sort((a, b) => {
          if (a.year > b.year && a.month > b.month) return -1;
          if (a.year < b.year && a.month < b.month) return 1;
          return 0;
        });
    },
    showDetails(data) {
      this.loadingPreview = true;
      setTimeout(() => {
        this.previewDetail = data;
        this.loadingPreview = false;
      }, 1000);
    },
    async getPaysheetData(selectedPaysheet) {
      this.loading = true;
      axios
        .post("/", {
          query: `
          {
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
            }
            personalActionHistory(where:{ paysheet: ${selectedPaysheet} }) {
              name
              value
              amount
              personalAction { name }
              employee { code }
              PAdeductISR
              type
            }
            overtimeHistory(where:{ paysheet: ${selectedPaysheet} }) {
              hours
              factor
              name
              date
              comment
              employee { code }
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          let index = 0;
          this.computedEmployees = data.paysheetHistory.map((h) => {
            const personalActions = data.personalActionHistory.filter(
                (pa) => pa.employee.code == h.code
              ),
              index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
              gratificationsList: personalActions.filter((pa) => pa.type == 2),
              discountsList: personalActions.filter((pa) => pa.type == 3),
              overtimeList: data.overtimeHistory.filter(
                (o) => o.employee.code == h.code
              ),
            };
          });
          this.loading = false;
        });
    },
    getRowClasses(k, ce, previewDetail) {
      const classes = [];
      if (ce.total < 0) {
        classes.push("bg-red-500 hover:bg-red-400 text-white");
      } else if (previewDetail && ce.id == previewDetail.id) {
        classes.push("bg-orange-400 hover:bg-orange-300");
      } else if (k % 2 == 0) {
        classes.push("bg-gray-100 hover:bg-gray-50");
      }
      return classes.join(" ");
    },
    printBoleta(values, options) {
      const selectedPaysheet = this.paysheets.find(
        (p) => p.id == this.selectedPaysheet
      );
      printBoleta(values, options, selectedPaysheet);
    },
    openPrintPayStub() {
      this.showPrintPayStub = true;
    },
    searchPSOptions(query) {
      if (query != "") {
        switch (this.payStubPrintOptions.type) {
          case 2:
            this.payStubSelectionOptions = this.computedDepartments.filter(
              (cd) => cd.toLowerCase().includes(query.toLowerCase())
            );
            break;
          case 3:
            this.payStubSelectionOptions = this.computedEmployeesList.filter(
              (ce) => ce.name.toLowerCase().includes(query.toLowerCase())
            );
            break;
        }
      } else {
        this.payStubSelectionOptions = [];
      }
    },
  },
  computed: {
    activePaysheets() {
      return this.paysheets.filter((p) => !p.active);
    },
    paysheetDetails() {
      const selectedPaysheet = this.selectedPaysheet;
      if (!R.isEmpty(selectedPaysheet)) {
        return this.paysheets.find((p) => p.id === selectedPaysheet);
      } else {
        return {};
      }
    },
    paysheetTotals() {
      const totals = ["", "", "", "", 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (const employee of this.computedEmployees) {
        totals[4] = totals[4] + parseFloat(employee.salaryForPayroll);
        totals[5] = totals[5] + parseFloat(employee.overtime);
        totals[6] = totals[6] + parseFloat(employee.gratification);
        totals[7] = totals[7] + parseFloat(employee.subtotalSalary);
        totals[8] = totals[8] + parseFloat(employee.socialEmployee);
        totals[9] = totals[9] + parseFloat(employee.afpEmployee);
        totals[10] = totals[10] + parseFloat(employee.taxes);
        totals[11] = totals[11] + parseFloat(employee.discounts);
        totals[12] = totals[12] + parseFloat(employee.total);
      }
      totals[4] = formatNumber(totals[4]);
      totals[5] = formatNumber(totals[5]);
      totals[6] = formatNumber(totals[6]);
      totals[7] = formatNumber(totals[7]);
      totals[8] = formatNumber(totals[8]);
      totals[9] = formatNumber(totals[9]);
      totals[10] = formatNumber(totals[10]);
      totals[11] = formatNumber(totals[11]);
      totals[12] = formatMoney(totals[12]);
      return totals;
    },
    filteredEmployees() {
      return this.computedEmployees.filter((e) => {
        let filterByName = true;
        let filterByNegative = true;
        if (this.searchValue != "") {
          filterByName = e.fullName
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        }
        if (this.negativePayments) {
          filterByNegative = e.total < 0;
        }

        return filterByName && filterByNegative;
      });
    },
    computedDepartments() {
      return [
        ...new Set(this.computedEmployees.map((ce) => ce.priorDepartment)),
      ];
    },
    computedEmployeesList() {
      return this.computedEmployees.map((ce) => ({
        name: ce.fullName,
        id: ce.id,
      }));
    },
  },
};
</script>
